<template>
<div class="row plain-element">
    <div v-if="!isLoggedIn()"  class="dashboard-cards">
        <NoPermissionComponent/>
    </div>
   <div v-if="getUsername() && getDivisionPlanData()" class="dashboard">
    <div class="row row-cards">
      <div class="row text-start row-back">
        <a class="back-link" @click="hasHistory() ? $router.go(-1): $router.push('/')">
          <span class="material-icons chevron-left">chevron_left</span> Back To Plan
        </a>
      </div>
    </div>
    <div class="card card-details">
      <p class="error"  v-if="getFormError()">

      </p>
      <p class="error"  v-else>
      </p>
      <DeleteDivisionPlanComponent
              :id = id
              :current_name = getDivisionPlanData().name
      />
    </div>
  </div>
</div>
</template>


<script>

import { mapGetters, mapActions } from "vuex";
import { hasHistory } from "@/common/general.js";
import DeleteDivisionPlanComponent from "@/components/division_plans/DeleteDivisionPlanComponent.vue";
import NoPermissionComponent from "@/components/NoPermissionComponent.vue"

export default {
  name: "DivisionPlanDelete",
  components: {
    DeleteDivisionPlanComponent,
    NoPermissionComponent,
  },
  props: {
    id: { type: Number, required: true },
  },
  data() {
    return {

    }
  },
  methods: {
    ...mapGetters(["getDivisionPlanData","getFormError", "getUsername", "isLoggedIn"]),
    ...mapActions(["fetchDivisionPlanData", "performSetFormError"]),
    hasHistory: hasHistory,
    getPlanDetails() {
      this.fetchDivisionPlanData({"id": this.id })
    },
  },

  created() {
    this.getPlanDetails();
    this.performSetFormError(null);
    document.title = "Delete Division Plan";
    window.scrollTo(0,0);
  },
  beforeRouteUpdate (to, from, next) {
    this.getPlanDetails();
    next();
  }
}


</script>
